module.exports = __webpack_public_path__ + "img/pick_2.e1eb90d1.png";